<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc" id="table-of-contents">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-mixed">Contents</h1>
</div>
</div>
</div>
</div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/forewordconfessionsofaweirdkid"><span class="item-title-text">Foreword: Confessions of a Weird Kid</span></a></p>
<p class="item-author">Jonathan Maberry</p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/imprisonedwiththepharaohs"><span class="item-title-text">Imprisoned with the Pharaohs</span></a></p>
<p class="item-author">Houdini</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><span href="#/thethingofathousandshapes" title="Link target outside of Sample"><span class="item-title-text">The Thing of a Thousand Shapes</span></span></p>
<p class="item-author">Otis Adelbert Kline</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><span href="#/themagicmirror" title="Link target outside of Sample"><span class="item-title-text">The Magic Mirror</span></span></p>
<p class="item-author">Mary S. Brown</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><span href="#/thevowonhalloween" title="Link target outside of Sample"><span class="item-title-text">The Vow on Halloween</span></span></p>
<p class="item-author">Lyllian Huntley Harris</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><span href="#/thewerewolfofstbonnot" title="Link target outside of Sample"><span class="item-title-text">The Werewolf of St. Bonnot</span></span></p>
<p class="item-author">Seabury Quinn</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><span href="#/theseathing" title="Link target outside of Sample"><span class="item-title-text">The Sea Thing</span></span></p>
<p class="item-author">Frank Belknap Long Jr.</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><span href="#/sleighbells" title="Link target outside of Sample"><span class="item-title-text">Sleigh Bells</span></span></p>
<p class="item-author">Hasan Vokine</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><span href="#/thefestival" title="Link target outside of Sample"><span class="item-title-text">The Festival</span></span></p>
<p class="item-author">H.P. Lovecraft</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><span href="#/thewerewolfofponkert" title="Link target outside of Sample"><span class="item-title-text">The Werewolf of Ponkert</span></span></p>
<p class="item-author">H. Warner Munn</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><span href="#/valeofthecorbies" title="Link target outside of Sample"><span class="item-title-text">Vale of the Corbies</span></span></p>
<p class="item-author">Arthur J. Burks</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><span href="#/thetenantsofbroussac" title="Link target outside of Sample"><span class="item-title-text">The Tenants of Broussac</span></span></p>
<p class="item-author">Seabury Quinn</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><span href="#/thephantomwolfhound" title="Link target outside of Sample"><span class="item-title-text">The Phantom Wolfhound</span></span></p>
<p class="item-author">Otis Adelbert Kline</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><span href="#/thegargoyle" title="Link target outside of Sample"><span class="item-title-text">The Gargoyle</span></span></p>
<p class="item-author">Greye La Spina</p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/originalpublicationinformation" title="Link target outside of Sample"><span class="item-title-text">Original Publication Information</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/abouttheeditors" title="Link target outside of Sample"><span class="item-title-text">About the Editors</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/ifyouliked" title="Link target outside of Sample"><span class="item-title-text">If You Liked …</span></span></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?cc0921f0